<template>
  <v-container style="max-width: 1140px;">
    <h1 class="display-1 mb-3">About</h1>

    <h3>Walk Audit in Warner Center</h3>
    <p>
    To promote active transportation in and around the Warner Center community, we have developed a Walk Audit tool which will help residents and visitors assess the area’s walkability. 
    </p>
    <p>
    Community members will use the tool to help us identify what problems and solutions might affect pedestrian travel in Warner Center. We hope that by enlisting volunteers to participate in a walk audit of the area we can help create a more accessible and pedestrian-friendly urban hub.
    </p>
  <v-img
    align-top
    width="100%"
    src="/img/hero/DSC03113.jpg"
    gradienta="to top right, rgba(100,115,201,.43), rgba(25,32,72,.7)">
  </v-img>    
  </v-container>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>

</style>